import { useState, useEffect } from 'react';

const C = {
  blue: '#6699ff',
  navy: '#0b1120',
  cream: '#f5f0e8',
  creamWarm: '#ede5d8',
  textBody: '#3a4860',
  white: '#ffffff',
};

const GA_ID = process.env.REACT_APP_GA_ID;

function loadGA() {
  if (!GA_ID || window.gaLoaded) return;
  window.gaLoaded = true;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (consent === 'accepted') {
      loadGA();
    } else if (consent === null) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const getConsent = () => {
    try { return localStorage.getItem('spc-cookie-consent'); }
    catch { return null; }
  };

  const setConsent = (value) => {
    try { localStorage.setItem('spc-cookie-consent', value); }
    catch {}
  };

  const handleAccept = () => {
    setConsent('accepted');
    loadGA();
    setVisible(false);
  };

  const handleDecline = () => {
    setConsent('declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 200,
      background: C.navy, borderTop: `1px solid rgba(102,153,255,0.15)`,
      padding: '0 0 env(safe-area-inset-bottom)',
      animation: 'fadeInUp 0.5s ease both',
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto', padding: '24px 40px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 24, flexWrap: 'wrap',
      }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <p style={{ fontSize: 14, color: C.cream, lineHeight: 1.6, marginBottom: showDetails ? 12 : 0 }}>
            We use cookies to analyze site traffic and improve your experience.
            {' '}
            <button
              onClick={() => setShowDetails(!showDetails)}
              style={{
                background: 'none', border: 'none', color: C.blue,
                fontSize: 14, cursor: 'pointer', textDecoration: 'underline',
                fontFamily: "'Manrope', sans-serif", padding: 0,
              }}
            >
              {showDetails ? 'Hide details' : 'Learn more'}
            </button>
          </p>
          {showDetails && (
            <div style={{ fontSize: 12, color: 'rgba(245,240,232,0.5)', lineHeight: 1.7 }}>
              <p style={{ marginBottom: 8 }}>
                <strong style={{ color: C.cream }}>Essential cookies:</strong> Required for the website to function. These cannot be disabled.
              </p>
              <p style={{ marginBottom: 8 }}>
                <strong style={{ color: C.cream }}>Analytics cookies:</strong> Help us understand how visitors interact with our website using Google Analytics. Data is anonymized.
              </p>
              <p>
                By clicking "Accept", you consent to the use of analytics cookies. You can change your preference at any time by clearing your browser data.
              </p>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: 12, flexShrink: 0 }}>
          <button
            onClick={handleDecline}
            style={{
              padding: '12px 24px', background: 'transparent',
              border: '1px solid rgba(245,240,232,0.2)', color: C.cream,
              fontFamily: "'Manrope', sans-serif", fontSize: 12, fontWeight: 600,
              letterSpacing: 1.5, textTransform: 'uppercase', cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            style={{
              padding: '12px 24px', background: C.blue, border: 'none',
              color: C.navy, fontFamily: "'Manrope', sans-serif", fontSize: 12,
              fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase',
              cursor: 'pointer', transition: 'all 0.3s ease',
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}